import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const VirgoShape = ({
  width = 40,
  height = 40,
  fillColor = '#FFF',
  style
}: BaseSVGType) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 48 48"
    xmlns="http://www.w3.org/2000/svg"
    style={style}
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Horoscope" fill={fillColor}>
        <path d="M45.7,39.9,37.1,26l5.3-8.3A9.4,9.4,0,0,0,43.1,8a9.3,9.3,0,0,0-8.3-5,9.6,9.6,0,0,0-6.1,2.3A6,6,0,0,0,24,3a6.4,6.4,0,0,0-4,1.5A6.4,6.4,0,0,0,16,3a6.4,6.4,0,0,0-4,1.5A6.4,6.4,0,0,0,8,3,6,6,0,0,0,2,9v6a2,2,0,0,0,4,0V9a2,2,0,0,1,4,0V34a2,2,0,0,0,4,0V9a2,2,0,0,1,4,0V34a2,2,0,0,0,4,0V9a2,2,0,0,1,4,0v.4a9.3,9.3,0,0,0,1.1,8.1l5.2,8.4-9,14a2,2,0,0,0,3.4,2.2l8-12.4,7.6,12.4A2,2,0,0,0,44,43a2.3,2.3,0,0,0,1.1-.3A2.1,2.1,0,0,0,45.7,39.9ZM30.5,15.3a5,5,0,0,1-.3-5.5,5.2,5.2,0,0,1,9.3.1,5,5,0,0,1-.4,5.5l-4.4,6.8Z" />
      </g>
    </g>
  </svg>
);

export default VirgoShape;
